import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";

// IMAGES
import { ReactComponent as Playlist } from "../../../Global/Icons/playlist.svg";
import { ReactComponent as Pdf } from "../../../Global/Icons/pdf.svg";

const multiple = nota.global.multiple;

const StyledGenreConceptBlock = styled(NanoFlex)`
  .blockInfoWrapper {
    padding: ${multiple * 2 + "px"} ${multiple + "px"};
    .headerBlockWrapper {
      margin-bottom: ${multiple + "px"};
      .typeCard {
        h4 {
          text-transform: uppercase;
          color: ${nota.color.secondary.secAquaGreen};
        }
        h5 {
          color: ${nota.color.secondary.secAquaGreen};
        }
      }
      .btnsWrapper {
        .iconContainer {
          width: auto;
          cursor: pointer;
          margin-left: ${multiple * 2 + "px"};
          .playlistIcon {
            height: 16px;
          }
          svg {
            height: 20px;
            width: auto;
            path {
              fill: ${nota.color.neutral.NeuOne};
            }
          }
          &:hover {
            opacity: 0.7;
          }
        }
        .activeIcon {
          svg {
            path {
              fill: ${nota.color.main.default};
            }
          }
        }
      }
    }
  }
  .hotFactorsWrapper {
    padding-top: 8px;
    position: relative;
    flex-direction: column-reverse;
    .hotFactorsInfo {
      background-color: ${nota.color.secondary.hotFactor};
      padding: 8px 15% 8px 8px;
      position: relative;
      clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
    }
    .btnsWrapper {
      width: 100%;
      padding-right: 0;
      position: inherit;
      top: 0;
      .iconContainer {
        width: auto;
        cursor: pointer;
        margin-left: ${multiple * 2 + "px"};
        .playlistIcon {
          height: 16px;
        }
        svg {
          height: 20px;
          width: auto;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .activeIcon {
        svg {
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
    }
  }
  .verdictWrapper {
    padding-top: 8px;
    position: relative;
    flex-direction: column-reverse;
    .verdictInfo {
      background-color: ${nota.color.secondary.verdict};
      padding: 8px 15% 8px 8px;
      position: relative;
      clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
      gap: 15px;

      p,
      h6 {
        color: ${nota.color.neutral.white};
      }

      .verdictBtnWrapper {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
          text-underline-offset: 3px;
          text-decoration-color: ${nota.color.neutral.white};
        }
      }
    }

    .noAccessVerdictInfo {
      background: ${nota.color.secondary.verdict};
      padding: 4px 3% 4px 4px;
      position: relative;
      clip-path: polygon(0px 0px, 85% 0px, 100% 100%, 0% 100%);

      .verdictInfoText {
        clip-path: polygon(0px 0px, 87% 0px, 100% 100%, 0% 100%);
        background: white;
        padding: 10px;

        p {
          padding-right: 20px;
        }

        .contactUs {
          -webkit-text-decoration: none;
          text-decoration: none;
          cursor: pointer;
          text-decoration: underline;
          color: ${nota.color.neutral.NeuOne};
        }
      }
    }

    .btnsWrapper {
      width: 100%;
      padding-right: 0;
      position: inherit;
      top: 0;
      .iconContainer {
        width: auto;
        cursor: pointer;
        margin-left: ${multiple * 2 + "px"};
        .playlistIcon {
          height: 16px;
        }
        svg {
          height: 20px;
          width: auto;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .activeIcon {
        svg {
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1180px) {
    .hotFactorsWrapper {
      flex-direction: column-reverse;
      .btnsWrapper {
        width: 100%;
        padding-right: 0;
        margin-bottom: 8px;
        position: inherit;
        top: 0;
      }
    }
    .evaluationWrapper {
      flex-direction: column-reverse;
      .btnsWrapper {
        width: 100%;
        padding-right: 0;
        margin-bottom: 8px;
        position: inherit;
        top: 0;
      }
    }
  }
  @media only screen and (max-width: 800px) {
    .blockInfoWrapper {
      padding-top: 0;
    }
    .hotFactorsWrapper {
      padding-top: 0px;
      margin-bottom: 8px;
    }
    .evaluationWrapper {
      padding-top: 0px;
      margin-bottom: 8px;
    }
  }
`;

export class GenreConceptBlock extends BaseComponent {
  constructor(props) {
    super(props);

    this.downloadVideoRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  downloadVideo = () => {
    this.downloadVideoRef.current.click();
  };

  onClickSearch = (obj) => {
    return window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "SearchFromCard", filter: obj } }));
  };

  scrollToEvaluation = () => {
    document.querySelector(".evaluationBlock").scrollIntoView();
  };

  render() {
    let btnsWrapper = !this._isExport ? (
      <NanoFlex className="btnsWrapper" justifyContent={"flex-end"}>
        <NanoFlex
          className={`iconContainer ${this.props.isPlaylistActive ? "activeIcon" : ""}`}
          title={this.translation.card.playlist}
          onClick={() => {
            if (this.props.onPlaylistClick) {
              this.props.onPlaylistClick();
            }
          }}>
          <Playlist className="playlistIcon" />
        </NanoFlex>
        <NanoFlex className="iconContainer">
          <Pdf
            title={this.translation.components.navSearchList.exportPdf}
            onClick={() => {
              if (this.props.onPdfExportClick) {
                this.props.onPdfExportClick();
              }
            }}
          />
        </NanoFlex>
      </NanoFlex>
    ) : null;

    let noEvaluationAccessSplit = this.translation.card.noEvaluationAccess.split("[CONTACT_US]");
    let noEvaluationAccess = (
      <Type.p>
        {noEvaluationAccessSplit[0]}
        <a class="contactUs" href="mailto:e-nota@glance-mediametrie.com">
          {this.translation.card.noEvaluationAccessContactUs}
        </a>
        {noEvaluationAccessSplit[1]}
      </Type.p>
    );

    return (
      <StyledGenreConceptBlock flexDirection={"column"}>
        {this.props.card.hotFactors && (
          <NanoFlex className="hotFactorsWrapper" alignItems={"flex-start"}>
            <NanoFlex className="hotFactorsInfo">
              <NanoFlex className="articleWrapper" justifyContent={"flex-start"}>
                <Type.p>{this.props.card.hotFactors}</Type.p>
              </NanoFlex>
            </NanoFlex>
            {btnsWrapper}
          </NanoFlex>
        )}
        {this.props.card.verdict && (
          <NanoFlex className="verdictWrapper" alignItems={"flex-start"}>
            {this._user.HasEvaluationAccess && (
              <NanoFlex className="verdictInfo" flexDirection={"column"} alignItems={"flex-start"}>
                <NanoFlex className="articleWrapper" justifyContent={"flex-start"}>
                  <Type.p>
                    <b>{this.translation.card.verdict.toUpperCase()}:</b> {this.props.card.verdict}
                  </Type.p>
                </NanoFlex>
                {!this._isExport && (
                  <NanoFlex className="verdictBtnWrapper" justifyContent={"flex-start"}>
                    <Type.h6 onClick={this.scrollToEvaluation}>
                      <i>{this.translation.card.evaluationClick}</i>
                    </Type.h6>
                  </NanoFlex>
                )}
              </NanoFlex>
            )}
            {!this._user.HasEvaluationAccess && (
              <NanoFlex className="noAccessVerdictInfo" flexDirection={"column"} alignItems={"flex-start"}>
                <NanoFlex className="verdictInfoText" flexDirection={"column"} alignItems={"flex-start"}>
                  {noEvaluationAccess}
                </NanoFlex>
              </NanoFlex>
            )}
            {!this.props.card.hotFactors && btnsWrapper}
          </NanoFlex>
        )}
        <NanoFlex className="blockInfoWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
          <NanoFlex className="headerBlockWrapper">
            <NanoFlex className="typeCard" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
              <Type.h4 className="clickableSearch" onClick={() => this.onClickSearch({ selectedGenresGroups: [this.props.card.idGenre] })}>
                <b>{this.props.card.genre}</b>
              </Type.h4>
              <Type.h5 className="clickableSearch" onClick={() => this.onClickSearch({ selectedGenres: [this.props.card.idSubGenre] })}>
                {this.props.card.subGenre}
              </Type.h5>
            </NanoFlex>
            {!this.props.card.hotFactors && !this.props.card.verdict && btnsWrapper}
          </NanoFlex>

          <NanoFlex className="textBlock" justifyContent={"flex-start"}>
            <Type.p justify>{this.props.card.concept}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledGenreConceptBlock>
    );
  }
}

// Set default props
GenreConceptBlock.defaultProps = {
  card: {},
};

export default GenreConceptBlock;

// --- // Documentation // --- //
/*
  import GenreConceptBlock from './../Partial/GenreConceptBlock.js';
  
  <GenreConceptBlock/>
  */
